import React from "react";
import { Button } from "reactstrap";

const getNavStates = (indx, length) => {
  let styles = [];
  for (let i = 0; i < length; i++) {
    if (i < indx) {
      styles.push("done");
    } else if (i === indx) {
      styles.push("doing");
    } else {
      styles.push("todo");
    }
  }
  return { current: indx, styles: styles };
};

const checkNavState = (currentStep, stepsLength) => {
  if (currentStep > 0 && currentStep < stepsLength - 1) {
    return {
      showPreviousBtn: true,
      showNextBtn: true,
    };
  } else if (currentStep === 0) {
    return {
      showPreviousBtn: false,
      showNextBtn: true,
    };
  } else {
    return {
      showPreviousBtn: true,
      showNextBtn: false,
    };
  }
};

export default class MultiStep extends React.Component {
  state = {
    showPreviousBtn: false,
    showNextBtn: true,
    compState: 0,
    navState: getNavStates(0, this.props.steps.length),
    showBackToHome: this.props.showBackToHome ?? false,
    backToInitialPage: this.props.backToInitialPage ?? null,
    removePrevOnLastStep: this.props.removePrevOnLastStep ?? false,
    lastStepIcon: this.props.lastStepIcon ?? null,
    disableAction: this.props.disableAction ?? false,
  };

  setNavState = (next) => {
    this.setState({
      navState: getNavStates(next, this.props.steps.length),
    });
    if (next < this.props.steps.length) {
      this.setState({ compState: next });
    }
    this.setState(checkNavState(next, this.props.steps.length));
  };

  handleKeyDown = (evt) => {
    if (evt.which === 13) {
      this.next();
    }
  };

  handleOnClick = (evt) => {
    if (
      evt.currentTarget.value === this.props.steps.length - 1 &&
      this.state.compState === this.props.steps.length - 1
    ) {
      this.setNavState(this.props.steps.length);
    } else {
      this.setNavState(evt.currentTarget.value);
    }
  };

  next = () => {
    this.setNavState(this.state.compState + 1);
  };

  skip = () => {
    this.setNavState(this.props.steps.length - 1);
  };

  previous = () => {
    if (this.state.compState > 0) {
      this.setNavState(this.state.compState - 1);
    }
  };

  getClassName = (className, i) => {
    return className + "-" + this.state.navState.styles[i];
  };

  renderSteps = () => {
    return this.props.steps.map((s, i) => (
      <li
        className={this.getClassName("form-wizard-step", i)}
        // onClick={this.handleOnClick}
        key={i}
        value={i}
      >
        {this.state.lastStepIcon && i === this.props.steps.length - 1 ? (
          <em>{this.state.lastStepIcon}</em>
        ) : (
          <em>{i + 1}</em>
        )}
        <span>{this.props.steps[i].name}</span>
      </li>
    ));
  };

  render() {
    return (
      <div onKeyDown={this.handleKeyDown}>
        <ol className="forms-wizard">{this.renderSteps()}</ol>
        {this.props.steps[this.state.compState].component}
        <div className="divider" />
        <div className="clearfix">
          <div
            style={
              this.props.showNavigation
                ? {
                    display: "flex",
                    justifyContent:
                      this.state.showPreviousBtn || this.props.showBackToHome
                        ? "space-between"
                        : "flex-end",
                  }
                : { display: "none" }
            }
          >
            <Button
              style={
                this.state.showPreviousBtn || this.props.showBackToHome
                  ? {
                      display:
                        this.state.removePrevOnLastStep &&
                        this.state.compState === this.props.steps.length - 1
                          ? "none"
                          : "block",
                      color: "#44CAE1",
                      border: "1px solid #44CAE1",
                      borderRadius: "5px",
                      padding: "15px 32px",
                      backgroundColor: "#fff",
                    }
                  : { display: "none" }
              }
              onClick={
                this.props.backToInitialPage && this.state.compState === 0
                  ? this.props.backToInitialPage
                  : this.previous
              }
            >
              戻る
            </Button>
            <div>
              <Button
                disabled={this.props.disableAction}
                style={
                  this.state.showNextBtn && this.props.showSkipButton
                    ? {
                        color: "#44CAE1",
                        backgroundColor: "transparent",
                        padding: "15px 32px",
                        border: "none",
                        borderRadius: "5px",
                      }
                    : { display: "none" }
                }
                onClick={this.skip}
              >
                スキップ
              </Button>
              <Button
                disabled={this.props.disableAction}
                style={
                  this.state.showNextBtn
                    ? {
                        backgroundColor: "#44CAE1",
                        color: "#fff",
                        padding: "15px 32px",
                        border: "none",
                        borderRadius: "5px",
                      }
                    : { display: "none" }
                }
                onClick={this.next}
              >
                次へ
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MultiStep.defaultProps = {
  showNavigation: true,
};
